const SOCKET_IO_PORT = 3001

module.exports.BACKEND_URL = process.env.REACT_APP_API_URL || 'backend'

const { protocol, hostname } = window.location

let socketUrl = `${protocol}//${hostname}`
if (process.env.NODE_ENV === 'development') {
  socketUrl += `:${SOCKET_IO_PORT}`
}

module.exports.SOCKET_URL = socketUrl



// WEBPACK FOOTER //
// ./src/config/environment.js